import { useState } from 'react';
import { Card, Row, Col, Table, Button } from 'react-bootstrap';
import CashMovementForm from './CashMovementForm';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

const CashSessionActive = ({ session, onRefresh }) => {
  const [showMovementModal, setShowMovementModal] = useState(false);
  const [movementType, setMovementType] = useState(null);

  const summary = session?.resumen || {};

  // Safely convert to number
  const toNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const handleMovementClick = (type) => {
    setMovementType(type);
    setShowMovementModal(true);
  };

  const handleMovementSubmit = () => {
    setShowMovementModal(false);
    onRefresh();
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return format(new Date(date), 'MM/dd/yyyy HH:mm', { locale: enUS });
  };

  return (
    <>
      <Card className="shadow-sm">
        <Card.Header className="bg-success text-white">
          <h5 className="mb-0">
            <i className="bi bi-check-circle me-2"></i>
            Active Session
          </h5>
        </Card.Header>
        <Card.Body>
          {/* General Info */}
          <Row className="mb-4">
            <Col md={6}>
              <p className="mb-1">
                <strong>Register:</strong> {summary.caja || 'N/A'}
              </p>
              <p className="mb-1">
                <strong>Point of Sale:</strong> {summary.punto_venta || 'N/A'}
              </p>
            </Col>
            <Col md={6}>
              <p className="mb-1">
                <strong>Opened:</strong> {formatDate(summary.fecha_apertura)}
              </p>
              <p className="mb-1">
                <strong>Status:</strong>{' '}
                <span className="badge bg-success">{summary.estado?.toUpperCase() || 'ACTIVE'}</span>
              </p>
            </Col>
          </Row>

          {/* Financial Summary */}
          <Row>
            <Col md={8}>
              <Table bordered size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td>
                      <strong>Opening Amount:</strong>
                    </td>
                    <td className="text-end">${toNumber(summary.monto_inicial).toFixed(2)}</td>
                  </tr>
                  <tr className="table-success">
                    <td>
                      <strong>Cash Sales:</strong>
                    </td>
                    <td className="text-end text-success fw-bold">
                      + ${toNumber(summary.monto_ventas_efectivo).toFixed(2)}
                    </td>
                  </tr>
                  <tr className="table-success">
                    <td>
                      <strong>Additional Income:</strong>
                    </td>
                    <td className="text-end text-success">+ ${toNumber(summary.monto_ingresos).toFixed(2)}</td>
                  </tr>
                  <tr className="table-danger">
                    <td>
                      <strong>Withdrawals:</strong>
                    </td>
                    <td className="text-end text-danger">- ${toNumber(summary.monto_retiros).toFixed(2)}</td>
                  </tr>
                  <tr className="table-primary">
                    <td>
                      <strong>Expected Cash in Drawer:</strong>
                    </td>
                    <td className="text-end fw-bold fs-5">${toNumber(summary.monto_esperado).toFixed(2)}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>

            <Col md={4}>
              <Card className="bg-light">
                <Card.Body>
                  <div className="text-center">
                    <small className="text-muted d-block mb-1">Total Movements</small>
                    <h3 className="mb-0">{summary.total_movimientos || 0}</h3>
                  </div>
                  <hr />
                  <div className="text-center">
                    <small className="text-muted d-block mb-1">Recorded Sales</small>
                    <h3 className="mb-0 text-success">{summary.total_ventas || 0}</h3>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Action Buttons */}
          <Row className="mt-4">
            <Col>
              <div className="d-flex gap-2 justify-content-end">
                <Button variant="outline-danger" size="sm" onClick={() => handleMovementClick('retiro')}>
                  <i className="bi bi-arrow-down-circle me-1"></i>
                  Record Withdrawal
                </Button>
                <Button variant="outline-success" size="sm" onClick={() => handleMovementClick('ingreso')}>
                  <i className="bi bi-arrow-up-circle me-1"></i>
                  Record Income
                </Button>
                <Button variant="outline-primary" size="sm" onClick={onRefresh}>
                  <i className="bi bi-arrow-clockwise me-1"></i>
                  Refresh
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Movement Modal */}
      {showMovementModal && (
        <CashMovementForm
          show={showMovementModal}
          onClose={() => setShowMovementModal(false)}
          onSubmit={handleMovementSubmit}
          sessionId={session.id}
          type={movementType}
        />
      )}
    </>
  );
};

export default CashSessionActive;